

import React from 'react';
import { connect } from 'react-redux';
import { setIsUserLoggedInTrue, setUserRegisterDetails, setLoginPage } from '../../General/Actions.js';
import ValidateForm from '../../Utils/formValidation';
import Network from '../../Utils/network.js';
import Swal from 'sweetalert2';
// import ApuaWhiteTextLogo from '../../ImageAssets/ApuaWhiteTextLogo.png';
import ApuaWhiteTextLogo from '../../ImageAssets/Apua_New_Logo.png';
import SignUpComponent from './SignUpComponent';
import LoadingAnimation from '../../Utils/loadingAnimation.js';
import Background from '../../ImageAssets/blueskyBackground.png';
import { Input, Button } from 'reactstrap';
import { FaArrowLeft } from 'react-icons/fa';

class UserRegisterPasswordPartComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            passwordInResetPasswordPart: "",
            confirmPasswordInResetPasswordPart: "",
            newPasswordhidden: true,
            confirmPasswordhidden: true,
            isPasswordInfoTooltipOpen: false
        }
    }

    submitButtonClicked = () => {
        if (ValidateForm.inputFieldMandatoryCheck("changePasswordContainer", this.props.locales)) {
            if (ValidateForm.inputFieldValueCompositionCheck("changePasswordContainer", this.props.locales)) {
                if (this.state.passwordInResetPasswordPart === this.state.confirmPasswordInResetPasswordPart) {
                    this.setState({ isLoading: true })
                    Network.executeAxios("userResetPassword", "POST", { "username": this.props.userDetails.username, "password": this.state.passwordInResetPasswordPart }, (response) => {
                        this.setState({ isLoading: false })
                        if (response.STATUS === "SUCCESS") {
                            this.props.setUserRegisterDetails("password", this.state.passwordInResetPasswordPart);
                            this.props.setLoginPage("pageName", "login");
                        }
                        else {
                            Swal.fire(this.props.locales.ResetPasswordSwal, "", "");
                        }
                    });

                } else {
                    Swal.fire(this.props.locales.ResetPasswordDoesNtMatchSwal, "", "");
                }
            }
        }


    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }


    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    }

    displayLabel(event, value, placeHolderText) {
        if (value != "") {
            event.target.previousSibling.classList.remove('d-none');
            event.target.placeholder = "";
        } else {
            event.target.previousSibling.classList.add('d-none');
            event.target.placeholder = placeHolderText;
        }
    }

    inputValueChange(name, value) {
        this.setState({ [name]: value })
    }
    arrowIconClicked() {
        this.props.setLoginPage("pageName", "login");
    }

    render() {
        return (
            <div>
                <div id="toastPopup" className="animated slideInRight d-none"></div>
                {this.state.isLoading ? <LoadingAnimation isVisible={true} /> : null}
                {this.componentContent()}
            </div>
        );
    }

    componentContent() {
        const forgetPasswordSetPasswordOuterMainContainerStyle = { height: (this.state.windowHeight) + 'px', display: "flex", flexDirection: "column", justifyContent: "space-between" };
        return (
            <div style={forgetPasswordSetPasswordOuterMainContainerStyle}>
                <div className="row m-0" style={{ flex: 1 }}>
                    <div className="col-md-6 p-0 d-none d-sm-block" >
                        <div className="leftPartBackgroundImage" style={{ display: "flex", flexDirection: "column", height: "100%", flex: 1, alignItems: "center", justifyContent: "center", background: `url(${Background}) 20%`, backgroundSize: 'cover' }}>
                            <SignUpComponent />
                        </div>
                    </div>
                    <div className="col-md-6 p-0" >
                        <div style={{ display: "flex", height: "100%", flex: 1, justifyContent: "center", backgroundColor: '#ffffff' }}>
                            {this.resetPasswordPartComponent()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }


    // resetPasswordPartComponent() {
    //         return (
    //         <div id="updatePasswordMainContainer" className="">
    //             <div id="updatePasswordPartHeading">{this.props.locales.UserUpdatePasswordLabel}
    //                      <span style={{ paddingLeft: 5}}><FaQuestionCircle id="passwordInfoTooltip" style={{ cursor: 'pointer',color: '#000000'}} /></span>
    //             </div>
    //             <div id="updatePasswordPart" style={{paddingTop: 25}}>
    //                     {/* <Input type="text" name="passwordInResetPasswordPart" className="loginCredItem input_data typePassword mandatoryFieldSpecial" placeholder={this.props.locales.RegistrationPartPasswordPlcText} value={this.state.passwordInResetPasswordPart} onChange={(event) => this.handleInputValueChange(event)} /> */}
    //                     <div className="form-group">
    //                         <div class="input-group">
    //                             <input type={this.state.newPasswordhidden ? "password" : "text"}
    //                                 className="form-control input_data mandatoryFieldWithoutStyle formGroup_value_withoutStyle typePassword"
    //                                 name="passwordInResetPasswordPart"
    //                                 maxLength="16"
    //                                 placeholder={this.props.locales.RegistrationPartPasswordPlcText}
    //                                 value={this.state.passwordInResetPasswordPart} onChange={(event) => this.handleInputValueChange(event)}
    //                                 style={{borderLeft:"3px solid #EE3124"}}
    //                             />
    //                             <div class="input-group-append">
    //                                 <span class="input-group-text" style={{ cursor: 'pointer', borderLeft: 0 }} onClick={()=>{this.setState({newPasswordhidden:!this.state.newPasswordhidden})}}>
    //                                     {this.state.newPasswordhidden 
    //                                         ? 
    //                                             <FaEye style={{fontSize:20,height:21}}/>
    //                                         : 
    //                                             <FaEyeSlash style={{fontSize:20,height:21}}/>
    //                                     }
    //                                 </span>
    //                             </div>
    //                             <Tooltip placement="top" isOpen={this.state.isPasswordInfoTooltipOpen} target="passwordInfoTooltip" toggle={()=>{this.setState({isPasswordInfoTooltipOpen:!this.state.isPasswordInfoTooltipOpen})}}>
    //                             {this.props.locales.ResetPswToolTipTxt}
    //                             </Tooltip>
    //                         </div>
    //                         <div className="errorDesc"></div>
    //                     </div>


    //                 <div className="form-group">
    //                     <div class="input-group">
    //                         <input type={this.state.confirmPasswordhidden ? "password" : "text"}
    //                             class="form-control input_data mandatoryFieldWithoutStyle formGroup_value_withoutStyle typePassword"
    //                             name="confirmPasswordInResetPasswordPart"
    //                             maxLength="16"
    //                             placeholder={this.props.locales.RegistrationPartPswConfirmPlcText} value={this.state.confirmPasswordInResetPasswordPart} 
    //                             onChange={(event) => this.handleInputValueChange(event)}
    //                             style={{borderLeft:"3px solid #EE3124"}}
    //                         />
    //                         <div class="input-group-append">
    //                             <span class="input-group-text" style={{ cursor: 'pointer', borderLeft: 0 }} onClick={()=>{this.setState({confirmPasswordhidden:!this.state.confirmPasswordhidden})}}>
    //                                 {this.state.confirmPasswordhidden 
    //                                     ? 
    //                                         <FaEye style={{fontSize:20,height:21}}/>
    //                                     : 
    //                                         <FaEyeSlash style={{fontSize:20,height:21}}/>
    //                                 }
    //                             </span>
    //                         </div>
    //                     </div>

    //                     <div className="errorDesc"></div>
    //                 </div>
    //                 <Button style={{marginTop: 15}} className="updatePasswordPartButton" onClick={() => { this.submitButtonClicked() }}>
    //                {this.props.locales.RegistrationPartPswSubmitBtn}
    //                 </Button>
    //             </div>
    //             <div className="updatePasswordPartFooter justify-content-center">
    //                 <div className="link"style={{fontWeight:"500"}}  onClick={() => { this.props.changeCurrentLoginPartTo("login") }}>{this.props.locales.RegistrationPartPswLoginLinkText}</div>
    //             </div>
    //         </div>
    //     );
    // }


    resetPasswordPartComponent() {
        return (
            <div className="loginPageLeftPart col-md-12 row p-0 m-0 pb-5">
                <div className="d-none d-sm-block d-md-none d-block col-md-12 p-0">
                    <div className="row col-md-12 m-auto py-2 px-2" style={{ backgroundColor: '#0285CA' }}>
                        <div className="col-md-12"><FaArrowLeft color="#fafafa" size="16" onClick={() => this.arrowIconClicked()} /> <img alt="" src={ApuaWhiteTextLogo} height="60" /></div>
                    </div>
                </div>
                <div className="col-md-12 row py-5 m-0 my-5 d-none d-sm-block">

                </div>
                <div className="col-md-12 row m-0">
                    <div className="col-md-1"></div>
                    <div className="col-md-9  pl-sm-5 pl-2 pt-3 mt-3" id="changePasswordContainer">
                        <div className="col-md-12 pb-3" style={{ fontSize: 30, color: '#404042', fontWeight: 400 }}>{this.props.locales.changePasswordSetYourPswTxt}</div>
                        <div className="form-group col-md-12 pb-3">
                            <label className="d-none animated slideInUp m-0" style={{ color: '#a3b4bc', fontSize: 12, position: 'absolute' }}>{this.props.locales.changePasswordEnterPswTxt}</label>
                            <Input type="password" name="passwordInResetPasswordPart" autoComplete="new-password" className="loginCredItem input_data mandatoryFieldSpecial typePassword pt-4 pb-3"
                                placeholder={this.props.locales.changePasswordNewPswPlc} onChange={(event) => this.inputValueChange("passwordInResetPasswordPart", event.target.value)}
                                onKeyUp={(event) => this.displayLabel(event, this.state.passwordInResetPasswordPart, this.props.locales.changePasswordNewPswPlc)} style={{ color: '#404042', fontWeight: 500 }} />
                            <div className="errorDesc" style={{ color: 'red', fontSize: 12, fontWeight: 400, position: 'absolute' }}></div>
                        </div>
                        <div className="form-group col-md-12" >
                            <label className="d-none animated slideInUp m-0" style={{ color: '#a3b4bc', fontSize: 12, position: 'absolute' }}>{this.props.locales.changePasswordConfirmPswTxt}</label>
                            <Input type="password" name="confirmPasswordInResetPasswordPart" autoComplete="new-password" className="loginCredItem input_data mandatoryFieldSpecial typePassword pt-4 pb-3"
                                placeholder={this.props.locales.changePasswordComfirmPswPlc} onChange={(event) => this.inputValueChange("confirmPasswordInResetPasswordPart", event.target.value)}
                                onKeyUp={(event) => this.displayLabel(event, this.state.confirmPasswordInResetPasswordPart, this.props.locales.changePasswordComfirmPswPlc)} style={{ color: '#404042', fontWeight: 500 }} />
                            <div className="errorDesc" style={{ color: 'red', fontSize: 12, fontWeight: 400, position: 'absolute' }}></div>
                        </div>
                        <div className="form-group col-md-12 pt-2">
                            {this.props.locales.SettingsCompCharecterToolTip}
                        </div>
                        <div className="col-md-12 pt-4">
                            <Button className="loginPageLoginButton" onClick={() => { this.submitButtonClicked() }}>
                                {this.props.locales.changePasswordDoneBtn}
                            </Button>
                        </div>
                    </div>
                    <div className="col-md-2"></div>
                </div>
            </div>
        )
    }

















}

const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        userRegisterDetails: state.userRegisterDetails,
        userDetails: state.userDetails
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setIsUserLoggedInTrue: function () {
            dispatch(setIsUserLoggedInTrue());
        },
        setUserRegisterDetails: function (key, payload) {
            dispatch(setUserRegisterDetails(key, payload));
        },
        setLoginPage: function (key, payload) {
            dispatch(setLoginPage(key, payload));
        }
    }
}

const UserRegisterPasswordPartComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(UserRegisterPasswordPartComponent)


export default UserRegisterPasswordPartComponentContainer;
